var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ml-5", staticStyle: { width: "95%" } },
    [
      _c("loading-overlay", {
        attrs: { active: _vm.isLoading, "can-cancel": true },
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "image-modal",
          attrs: { id: "bv-modal", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v("\n\t\t\tCreate New Badge Image\n\t\t")]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm.spinner
            ? _c("div", { staticClass: "text-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "spinner-grow text-primary m-5",
                    attrs: { role: "status" },
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("Loading..."),
                    ]),
                  ]
                ),
              ])
            : _c(
                "div",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Region",
                        "label-for": "example-selected",
                        "label-cols-lg": "3",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c(
                                    "b-input-group-text",
                                    {
                                      staticClass: "input-group-text-alt",
                                      staticStyle: { cursor: "pointer" },
                                    },
                                    [
                                      _c("b-form-checkbox", {
                                        attrs: {
                                          id: "checkbox-3",
                                          name: "checkbox-2",
                                          checked:
                                            _vm.regionid == null ? true : false,
                                          "unchecked-value": "not_accepted",
                                        },
                                        on: {
                                          change: () => (_vm.regionid = null),
                                        },
                                      }),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\tNull\n\t\t\t\t\t\t"
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: { id: "example-selected", plain: "" },
                              model: {
                                value: _vm.regionid,
                                callback: function ($$v) {
                                  _vm.regionid = $$v
                                },
                                expression: "regionid",
                              },
                            },
                            [
                              _c(
                                "b-form-select-option",
                                { attrs: { value: null } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\tPlease select an option\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.region, function (reg, index) {
                                return _c(
                                  "b-form-select-option",
                                  { key: index, attrs: { value: reg.id } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(reg.id) +
                                        " | " +
                                        _vm._s(reg.name) +
                                        "\n\t\t\t\t\t\t"
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Language",
                        "label-for": "example-selecting",
                        "label-cols-lg": "3",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c(
                                    "b-input-group-text",
                                    {
                                      staticClass: "input-group-text-alt",
                                      staticStyle: { cursor: "pointer" },
                                    },
                                    [
                                      _c("b-form-checkbox", {
                                        attrs: {
                                          id: "checkbox-2",
                                          name: "checkbox-1",
                                          checked:
                                            _vm.langid == null ? true : false,
                                          "unchecked-value": "not_accepted",
                                        },
                                        on: {
                                          change: () => (_vm.langid = null),
                                        },
                                      }),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\tNull\n\t\t\t\t\t\t"
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: { id: "example-selecting", plain: "" },
                              model: {
                                value: _vm.langid,
                                callback: function ($$v) {
                                  _vm.langid = $$v
                                },
                                expression: "langid",
                              },
                            },
                            [
                              _c(
                                "b-form-select-option",
                                { attrs: { value: null } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\tPlease select an option\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.language, function (lang, id) {
                                return _c(
                                  "b-form-select-option",
                                  { key: id, attrs: { value: lang.id } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(lang.id) +
                                        " | " +
                                        _vm._s(lang.name) +
                                        "\n\t\t\t\t\t\t"
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Image", "label-cols-lg": "3" } },
                    [
                      _c("b-form-file", {
                        ref: "image",
                        attrs: {
                          id: "image",
                          placeholder: _vm.placeHolders.thumbnailPlaceholder,
                        },
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.updateImagePreview.apply(null, arguments)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.imagePreview
                        ? _c("div", { staticClass: "thumbnail" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.imagePreview,
                                alt: "",
                                srcset: "",
                                height: "100",
                                width: "100",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: { click: _vm.removeImage },
                              },
                              [_vm._v("\n\t\t\t\t\t\t✖ Remove\n\t\t\t\t\t")]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3",
                      attrs: { block: "" },
                      on: { click: _vm.addBadgeImage },
                    },
                    [_vm._v("\n\t\t\t\tSave\n\t\t\t")]
                  ),
                ],
                1
              ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "image-edit-modal",
          attrs: { id: "bv-edit-modal", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v("\n\t\t\tEdit Badge Image\n\t\t")]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm.spinner
            ? _c("div", { staticClass: "text-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "spinner-grow text-primary m-5",
                    attrs: { role: "status" },
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("Loading..."),
                    ]),
                  ]
                ),
              ])
            : _c(
                "div",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Region",
                        "label-for": "region-select",
                        "label-cols-lg": "3",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c(
                                    "b-input-group-text",
                                    {
                                      staticClass: "input-group-text-alt",
                                      staticStyle: { cursor: "pointer" },
                                    },
                                    [
                                      _c("b-form-checkbox", {
                                        attrs: {
                                          id: "checkbox-3",
                                          name: "checkbox-2",
                                          checked:
                                            _vm.editBadgesDetails.regionid ==
                                            null
                                              ? true
                                              : false,
                                          "unchecked-value": "not_accepted",
                                        },
                                        on: {
                                          change: () =>
                                            (_vm.editBadgesDetails.regionid =
                                              null),
                                        },
                                      }),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\tNull\n\t\t\t\t\t\t"
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: { id: "region-select", plain: "" },
                              model: {
                                value: _vm.editBadgesDetails.regionid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editBadgesDetails,
                                    "regionid",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "editBadgesDetails.regionid",
                              },
                            },
                            _vm._l(_vm.region, function (reg, index) {
                              return _c(
                                "b-form-select-option",
                                { key: index, attrs: { value: reg.id } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(reg.id) +
                                      " | " +
                                      _vm._s(reg.name) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Language",
                        "label-for": "language-select",
                        "label-cols-lg": "3",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c(
                                    "b-input-group-text",
                                    {
                                      staticClass: "input-group-text-alt",
                                      staticStyle: { cursor: "pointer" },
                                    },
                                    [
                                      _c("b-form-checkbox", {
                                        attrs: {
                                          id: "checkbox-4",
                                          name: "checkbox-6",
                                          checked:
                                            _vm.editBadgesDetails.languageid ==
                                            null
                                              ? true
                                              : false,
                                          "unchecked-value": "not_accepted",
                                        },
                                        on: {
                                          change: () =>
                                            (_vm.editBadgesDetails.languageid =
                                              null),
                                        },
                                      }),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\tNull\n\t\t\t\t\t\t"
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: { id: "language-select", plain: "" },
                              model: {
                                value: _vm.editBadgesDetails.languageid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editBadgesDetails,
                                    "languageid",
                                    $$v
                                  )
                                },
                                expression: "editBadgesDetails.languageid",
                              },
                            },
                            _vm._l(_vm.language, function (lang, id) {
                              return _c(
                                "b-form-select-option",
                                { key: id, attrs: { value: lang.id } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(lang.id) +
                                      " | " +
                                      _vm._s(lang.name) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Image", "label-cols-lg": "3" } },
                    [
                      _c("b-form-file", {
                        ref: "editimage",
                        attrs: {
                          id: "editimage",
                          placeholder: _vm.placeHolders.editBadgesPlaceholder,
                        },
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.updateEditPreview.apply(null, arguments)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.editBadgesDetails.url
                        ? _c("div", { staticClass: "thumbnail" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.editBadgesDetails.url,
                                alt: "",
                                srcset: "",
                                height: "100",
                                width: "100",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: { click: _vm.removeEditImage },
                              },
                              [_vm._v("\n\t\t\t\t\t\t✖ Remove\n\t\t\t\t\t")]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3",
                      attrs: { block: "" },
                      on: {
                        click: function ($event) {
                          return _vm.editBadgeImage()
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\tSave\n\t\t\t")]
                  ),
                ],
                1
              ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12", lg: "12", sm: "12" } },
            [
              _c(
                "b-tabs",
                { attrs: { card: "", "content-class": "mt-3", fill: "" } },
                [
                  _c(
                    "b-tab",
                    { attrs: { title: "Badge properties", active: "" } },
                    [
                      _c(
                        "base-block",
                        {
                          attrs: { title: "Badge properties", "header-bg": "" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-block text-center" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "form-group",
                                  attrs: {
                                    label: "Name: ",
                                    "label-for": "block-form1-name",
                                    "label-cols-lg": "3",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "control" },
                                    [
                                      _vm.singleBadge.name
                                        ? _c("b-form-input", {
                                            ref: "badgeImageName",
                                            attrs: { type: "text" },
                                            model: {
                                              value: _vm.singleBadge.name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.singleBadge,
                                                  "name",
                                                  $$v
                                                )
                                              },
                                              expression: "singleBadge.name",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    { attrs: { title: "Badge Images" } },
                    [
                      _c(
                        "base-block",
                        { attrs: { title: "Badge Images", "header-bg": "" } },
                        [
                          _c(
                            "b-row",
                            { staticClass: "d-flex justify-content-end" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "mb-2 d-flex justify-content-end",
                                  attrs: { md: "6" },
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: { to: "#" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showImageModal.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\tAdd Image\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { ref: "badgeImage" }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: { title: "Offerings" },
                      on: { click: () => (_vm.display.offeringDisplay = true) },
                    },
                    [
                      _vm.display.offeringDisplay
                        ? _c("OfferingTable", {
                            attrs: { "route-id": _vm.routeId },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: { title: "PDPs" },
                      on: { click: () => (_vm.display.badgePdpDisplay = true) },
                    },
                    [
                      _vm.display.badgePdpDisplay
                        ? _c("BadgePdpTable", {
                            attrs: { "route-id": _vm.routeId },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: { title: "Lister Items" },
                      on: {
                        click: () =>
                          (_vm.display.productCategoryDisplay = true),
                      },
                    },
                    [
                      _vm.display.productCategoryDisplay
                        ? _c("BadgeProductCategoryTable", {
                            attrs: { "route-id": _vm.routeId },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }